// ==================== Start SLider ====================
const benefitsSliderSlides = document.querySelectorAll('#benefits-images--slider .keen-slider__slide');

if (benefitsSliderSlides.length > 1) {
  var slider = new KeenSlider("#benefits-images--slider", {
    loop: true,
  },
  [
    navigation,
    (slider) => {
      let timeout
      let mouseOver = false
      function clearNextTimeout() {
        clearTimeout(timeout);
      }
      function nextTimeout() {
        clearTimeout(timeout)
        if (mouseOver) return
        timeout = setTimeout(() => {
          slider.next();
        }, 5000)
      }
      slider.on("created", () => {
        slider.container.addEventListener("mouseover", () => {
          mouseOver = true
          clearNextTimeout()
        })
        slider.container.addEventListener("mouseout", () => {
          mouseOver = false
          nextTimeout()
        })
        nextTimeout()
      })
      slider.on("dragStarted", clearNextTimeout)
      slider.on("animationEnded", nextTimeout)
      slider.on("updated", nextTimeout)
    },
  ]);
}

// Lazyload fix
document.addEventListener('lazybeforesizes', function(e) {
  if (e.target.classList.contains('benefits-image')) {
    e.detail.width = parseInt(getComputedStyle(e.target.closest('.benefits-images__container')).width) || e.detail.width;
  }
})
// ==================== End SLider ====================